export function formatMoney(money) {
  // let cacheMoney = money.toString().split('.')
  // let integer = cacheMoney[0] // 整数，元
  // let decimal = cacheMoney[1].padEnd(2, '0') // 小数，角分

  return money.toFixed(2).toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}



// WEBPACK FOOTER //
// ./src/utils/formatMoney.js